import { render } from "./TokenListPage.vue?vue&type=template&id=1db4767b&scoped=true"
import script from "./TokenListPage.vue?vue&type=script&lang=js"
export * from "./TokenListPage.vue?vue&type=script&lang=js"

import "./TokenListPage.vue?vue&type=style&index=0&id=1db4767b&scoped=true&lang=css"

import exportComponent from "/var/www/cmtycoin.xyz/repo/frontend-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1db4767b"]])

export default __exports__